import { Home, Circle } from "react-feather";

export default [
  {
    id: "dashboards-legacy",
    title: "Dashboards",
    icon: <Home size={20} />,
    badge: "light-warning",

    children: [
      {
        id: "eCommerceDash-legacy",
        title: "Loja da Marca",
        icon: <Circle size={12} />,
        navLink: "/dashboard/ecommerce",
        action: "true",
        resource: "wcfm_vendor",
      },
    ],
  },
];
